let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lr4U0")).then(() => parcelRequire('aoeTu'));